var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousingQueue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.128 53.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Icon of people waiting in a queue")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963",
    transform: "translate(-1049 -575.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-686,307.813v-4.85h71.128v4.85Zm42.952-22.352a25.606,25.606,0,0,0-11-9.948,15.66,15.66,0,0,1,10.094-3.675,15.758,15.758,0,0,1,14.965,10.879A2.1,2.1,0,0,1-631,285.461Zm17.069-6.531a20.084,20.084,0,0,0-7.45-8.3,12.393,12.393,0,0,1,6.856-2.062,12.482,12.482,0,0,1,11.383,7.387,2.108,2.108,0,0,1-1.924,2.97Zm-24.789-18.119A6.819,6.819,0,0,1-643.956,254a6.819,6.819,0,0,1,6.811,6.811,6.819,6.819,0,0,1-6.811,6.811A6.819,6.819,0,0,1-650.768,260.811Zm19.016-1.633A5.185,5.185,0,0,1-626.573,254a5.184,5.184,0,0,1,5.179,5.179,5.184,5.184,0,0,1-5.179,5.179A5.185,5.185,0,0,1-631.751,259.178Z",
    transform: "translate(1735 321.731)",
    fill: "var(--color--primary-text)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-683.888,296.418a2.1,2.1,0,0,1-2.06-2.557,21.245,21.245,0,0,1,20.693-16.544,21.246,21.246,0,0,1,20.692,16.544,2.1,2.1,0,0,1-2.06,2.557Zm9.082-32.867A9.562,9.562,0,0,1-665.256,254a9.561,9.561,0,0,1,9.55,9.551,9.561,9.561,0,0,1-9.55,9.551A9.562,9.562,0,0,1-674.807,263.551Z",
    transform: "translate(1735.404 321.731)",
    fill: "var(--color--primary)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingQueue);
export default __webpack_public_path__ + "static/media/housing-queue.ee55cd0152480369254117903c081616.svg";
export { ForwardRef as ReactComponent };